import React, {useMemo, useRef, useCallback} from "react";
import { Grid } from "@mui/material";
import SortFilter from '../../SortFilter/SortFilter';
import { sortByFields } from "../formatSpaceUsage";
import { getAllLocationsByBuyer } from "../../location/requests/location-requests";
import useGetRequestBody from "../../../hooks/useGetRequestBody";

import {withSnackbar} from "../../hocs/withSnackbar";

const BuyerSpaceUsageFilters = ({
  setSortBy, 
  setSelectedLocation, 
  setStartDate, 
  setEndDate, 
  setBookingNumber, 
  setInvoiceNumber, 
  snackbarShowMessage, 
  setSortDir, 
  savedStartDate, 
  savedEndDate,
  savedLocationId,
  savedBookingNumber,
  savedInvoiceNumber,
  savedSortBy  
}) => {

  const buyerLocations = useGetRequestBody(getAllLocationsByBuyer, useMemo(() => [], []), snackbarShowMessage);

  const locations = useMemo(() => {
    return [{id: "", locationName: "All"}, ...buyerLocations];
  },[buyerLocations]);

  const initialRender = useRef(true);

  const handleCallback = useCallback((e) => {
    const parseFilters = (filterArray) => {
      const bookingNumber = filterArray.find(item => item.name === "bookingNumber")?.value;
      const invoiceNumber = filterArray.find(item => item.name === "invoiceNumber")?.value;
      setBookingNumber(bookingNumber);
      setInvoiceNumber(invoiceNumber);
    }
    if (!initialRender.current) {
        setSelectedLocation(e.location);
        setSortBy(e.sortBy);
        setStartDate(e.startDate);
        setEndDate(e.endDate);
        parseFilters(e.filters)
        setSortDir(e.sortDir)
    } else {
        initialRender.current = false;
    }
  }, [setBookingNumber, setInvoiceNumber, setSelectedLocation, setSortBy, setStartDate, setEndDate, setSortDir]);


  const filterByOptions = useMemo(() => {
    return [
      {name: "bookingNumber", label: "Booking Number", value: savedBookingNumber, numberField: true, inputProps: { inputMode: "numeric" }},
      {name: "invoiceNumber", label: "Invoice Number", value: savedInvoiceNumber, numberField: true, inputProps: { inputMode: "numeric" }}
    ];
  }, [savedBookingNumber, savedInvoiceNumber]);

  return (
    <Grid item container spacing={2} direction={"column"}>
      <SortFilter
        filterCallback={handleCallback}
        sortByOption={sortByFields}
        locations={locations}
        filterByOption={filterByOptions}
        defaultStartDate={savedStartDate}
        defaultEndDate={savedEndDate}
        defaultSortBy={savedSortBy}
        defaultLocationId={savedLocationId}
        sortDir={"asc"}
      />
    </Grid>
  )
};

export default withSnackbar(BuyerSpaceUsageFilters);
